// extracted by mini-css-extract-plugin
export default {"root":"YfTKUu2Km_7xdnlpku_J","header":"jfEu9qRKi85703rqZ_i8","content":"alEj7L8I8JynpvBmbKlg"};